import React, { useEffect, useState } from 'react'
import { fetchClassifiedCategories } from "../../services/Service";
import { ServiceTypeConfig } from '../../types/Service';
import { Popup } from 'semantic-ui-react';
import sendToast from '../../../utils/Toast';
import "./style.less"
import { useHistory } from 'react-router-dom';
import { useFacility } from '../../contexts/facility/FacilityContext';

interface StepOneProps {
    setSelectedServiceCategoryName: React.Dispatch<React.SetStateAction<string>>;
    setSelectedServiceCategoryHeading: React.Dispatch<React.SetStateAction<string>>;
    setIsFetching: React.Dispatch<React.SetStateAction<boolean>>;
    setStepForm: React.Dispatch<React.SetStateAction<number>>;
    FacilityId: string;
}

const StepOne: React.FC<StepOneProps> = ({ setSelectedServiceCategoryName, setSelectedServiceCategoryHeading, setIsFetching, setStepForm, FacilityId }) => {
    const history = useHistory();
    const { facilityDetails, loading: facilityLoading } = useFacility();
    const [serviceCategories, setServiceCategories] = useState<ServiceTypeConfig[]>([]);

    useEffect(() => {
        const fetchServiceCategories = async () => {
            try {
                setIsFetching(true);

                const allActiveCategories = await fetchClassifiedCategories({ facilityId: FacilityId });
                setServiceCategories(allActiveCategories?.Result?.Content || []);
            } catch (error) {
                sendToast('error', error instanceof Error ? error.message : 'An error occurred while fetching service categories');
            } finally {
                setIsFetching(false);
            }
        };
        fetchServiceCategories();
    }, [FacilityId])

    const handleServiceCategoryClick = (category: ServiceTypeConfig) => {
        const categoryName = category.Name;
        const categoryHeading = renderName(category);

        if (categoryName === "Menu") {
            handleRedirectToDining();
        } else {
            setSelectedServiceCategoryName(categoryName);
            setSelectedServiceCategoryHeading(categoryHeading);
            setStepForm(2);
        }
    }


    const handleRedirectToDining = () => {
        if (facilityLoading && !facilityDetails) {
            sendToast('warn', 'Still loading facility information. Please try again.');
            return;
        }
        if (facilityDetails?.featureConfigs?.configurations?.dining) {
            history.push({ pathname: `/menu` });
        } else {
            sendToast('warn', 'Dining feature is not enabled for this facility. Please contact support to enable it.');
        }
    };

    const renderName = (category: ServiceTypeConfig) => {
        if (category.Name === "Menu" && !category.alternativeName) {
            return "Dining";
        } else {
            return category.alternativeName || category.Name;
        }
    };

    return (
        <div className='divCenter categoryContainer'>
            <div className='dept-grid'>
                {serviceCategories && serviceCategories.length > 0 ? (
                    <>
                        {serviceCategories.map((category) => (
                            <button
                                key={category.Name}
                                type="button"
                                className="dept-card"
                                onClick={() => handleServiceCategoryClick(category)}
                            >
                                <div className="dept-card-name">
                                    {(category.alternativeName || category.Name).length > 45 ? (
                                        <Popup
                                            trigger={
                                                <span>
                                                    {(category.alternativeName || category.Name).slice(0, 45) + '...'}
                                                </span>
                                            }
                                            content={category.alternativeName || category.Name}
                                            position='top center'
                                        />
                                    ) : (
                                        renderName(category)
                                    )}
                                </div>
                            </button>
                        ))}
                    </>
                ) : (
                    <span>No Service Categories Available</span>
                )}
            </div>
        </div>
    )
}

export default StepOne;